import { render, staticRenderFns } from "./summary-report-big-donut-card.vue?vue&type=template&id=791038dd"
import script from "./summary-report-big-donut-card.vue?vue&type=script&lang=js"
export * from "./summary-report-big-donut-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports